<template>
  <div v-show="!isAdminUser && canLoadPage" class="workato-nonadmin">
    <div class="text-danger">{{ error }}</div>
    <div v-show="!isTenantActivated" id="nonadmin-deny-access" class="workflow-landing">
      <div class="video-panel col-md-6">
        <iframe class="embedded-video"
                title="workatoActivate"
                :src="workatoPageUrl">
        </iframe>
      </div>
      <div class="info-panel col-md-6">
        <h1>Your Workato account has not been enabled as yet</h1>
        <div class="info-text col-md-6">Please contact your brand administrator to enable your account in order to activate it</div>
        <h1 class="admin-details">ADMIN DETAILS:</h1>
        <div v-for="users in workatoAdmins" :key="users" class="admin-user-wrapper">
          <span class="admin-user-email">{{ users.email }}</span>
          <span class="admin-user-name">({{ users.fullName }})</span>
        </div>
        <div class="info-panel-help"><span class="info-text">New to Workato? </span><a href="https://www.workato.com/" target="_blank">Learn More</a></div>
      </div>
    </div>

    <div v-show="isTenantActivated" id="nonadmin-activation" class="workflow-landing">
      <div class="video-panel col-md-6">
        <iframe class="embedded-video"
                title="workatoActivate"
                :src="workatoPageUrl">
        </iframe>
      </div>
      <div class="info-panel col-md-6">
        <h1>Automate workflows with Workato</h1>
        <div class="col-lg-7">Activate our embedded Workato workspace inside LivePerson for more efficient integrations.</div>
        <IhuButton variant="primary" @click="createNewWorkatoUserTrigger">Let's begin</IhuButton>
        <div class="info-panel-help mt-5-rem">New to Workato? <a href="https://www.workato.com/" target="_blank">Learn More</a></div>
      </div>
    </div>
  </div>
</template>

<script lang="js">

  import { Vuex } from 'vue-infra';
  import { MODULES_PATHS } from '@/store';
  import { ACTION_TYPES as WORKATO_CONFIGURATION_ACTION_TYPES } from '@/store/modules/data/workato-configuration/actions';
  import { GETTER_TYPES as BASE_COLLECTION_GETTER_TYPES } from '@/store/modules/data/workato-configuration/getters';
  import IhuButton from '@/components/common/ihu-button';
  import { appName } from '../../../config';
  import { HTTP_STATUS_CODE, WORKATO_CONFIG } from '../../common/consts';

  const mapActions = Vuex.mapActions;
  const mapGetters = Vuex.mapGetters;

  export default {
    name: 'workato-nonadmin',
    components: {
      IhuButton,
    },
    props: [],
    data() {
      return {
        workatoAdmins: [],
        error: '',
        isTenantActivated: false,
        canLoadPage: false,
      };
    },
    computed: {
      ...mapGetters(MODULES_PATHS.DATA.WORKATO_SITE_SETTINGS, {
        getWorkatoAdmins: BASE_COLLECTION_GETTER_TYPES.GET_WORKATO_ADMINS,
        getExistingWorkatoAccount: BASE_COLLECTION_GETTER_TYPES.GET_EXISTING_WORKATO_ACCOUNT,
        getNewWorkatoUser: BASE_COLLECTION_GETTER_TYPES.GET_NEW_WORKATO_USER,
        getWorkatoToken: BASE_COLLECTION_GETTER_TYPES.GET_WORKATO_TOKEN,
      }),
    },
    mounted() {
      this.checkPermission();
    },
    methods: {
      ...mapActions(MODULES_PATHS.DATA.WORKATO_SITE_SETTINGS, {
        fetchWorkatoAdmins: WORKATO_CONFIGURATION_ACTION_TYPES.FETCH_WORKATO_ADMINS,
        fetchExistingWorkatoAccount: WORKATO_CONFIGURATION_ACTION_TYPES.FETCH_EXISTING_WORKATO_ACCOUNT,
        createNewWorkatoUser: WORKATO_CONFIGURATION_ACTION_TYPES.CREATE_NEW_WORKATO_USER,
        fetchIhubConfig: WORKATO_CONFIGURATION_ACTION_TYPES.FETCH_IHUB_CONFIG,
      }),
      async createNewWorkatoUserTrigger() {
        try {
          await this.createNewWorkatoUser();
          // this.$router.push(`/${appCode}/integration`);
          this.$router.push({ name: 'workato-integration' });
        } catch (error) {
          this.error = error.response.data;
        }
      },
      async getIhubConfig(workatoVideoConfig) {
        const responseObject = await this.fetchIhubConfig(workatoVideoConfig);
        if (responseObject) {
          // this.workatoPageUrl = responseObject.configValue;
          this.workatoPageUrl = responseObject[workatoVideoConfig];
        }
      },
      getParent() {
        let p = this.$parent;
        // eslint-disable-next-line lodash/prefer-lodash-typecheck
        while (typeof p !== 'undefined') {
          if (p.$options.name === appName) {
            return p;
          }
            p = p.$parent;
        }
        return false;
      },
      async checkPermission() {
        const parent = await this.getParent();
        this.isAdminUser = parent.isAdminUser;
        this.token = parent.token;
        await this.fetchExistingWorkatoAccount();
        const existingWorkatoAccount = await this.getExistingWorkatoAccount;
        if (!this.isAdminUser && !this.token && existingWorkatoAccount.responseCode === HTTP_STATUS_CODE.OK) {
          await this.getIhubConfig(WORKATO_CONFIG.WORKATO_ENTER_PAGE_VIDEO_URL);
          this.isTenantActivated = true;
        } else if (!this.isAdminUser && !this.token && existingWorkatoAccount.responseCode !== HTTP_STATUS_CODE.OK) {
          await this.fetchWorkatoAdmins();
          this.workatoAdmins = await this.getWorkatoAdmins;
          await this.getIhubConfig(WORKATO_CONFIG.WORKATO_ACTIVATE_PAGE_VIDEO_URL);
          this.isTenantActivated = false;
        }
        this.canLoadPage = true;
      },
    },
  };


</script>

<style scoped lang="scss">
@import './workato';

</style>
